import { objectOf } from "@altostra/type-validations";
import { boolean, number } from "@altostra/type-validations/lib/primitives";

export const isUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupIdResult = objectOf({
  results: objectOf({
    estimated: boolean,
    subscribed: number,
    unsubscribed: number,
  }),
});
